<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div class="auto-complete-filter">
  <mat-form-field>
    <input type="text"
           #eFilterText
           [placeholder]="headerName"
           matInput
           [matAutocomplete]="auto"
           [(ngModel)]="selectedOption"
           (ngModelChange)="this.selectOptions($event)">
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredOptions" [value]="option">{{ option }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
